<ng-template let-data="adtData" let-emitter="captureEvents" #userActionCell>
    <app-user-action-cell [data]="data" (emitter)="emitter($event)" [readonly]="readonly"></app-user-action-cell>
</ng-template>

<ng-template let-data="adtData" #userRoleCell>
    <app-user-role-cell [data]="data"></app-user-role-cell>
</ng-template>

<ng-template let-data="adtData" #userStatusCell>
    <app-user-status-cell [data]="data"></app-user-status-cell>
</ng-template>

<div id="accountUsers" style="margin-top: 3rem;">
    <app-header title="Users"></app-header>

    <header class="px-4 pt-5">
        <div class="d-flex align-items-center justify-content-between mb-2">
            <div class="headline-4">Users</div>
            <div *ngIf="!this.readonly" class="d-flex align-items-center">
                <button id="addNewAccount" class="btn btn--paybee btn-sm modal-confirm-button">Add New User...</button>
            </div>
        </div>
        <span class="grey-text subtitle-1">View and edit users added to this account</span>
    </header>

    <div class="p-4">
        <div class="table--paybee">
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table">
                <thead class="thead-light">
                    <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Role</th>
                        <th>Status</th>
                        @if(!readonly) {
                            <th></th>
                        }
                    </tr>
                </thead>
            </table>
        </div>
    </div>
</div>
